// extracted by mini-css-extract-plugin
module.exports = {"ratingButton":"RatingButton_ratingButton__3QZrK"};